import { render, staticRenderFns } from "./UserEditTabTargets.vue?vue&type=template&id=eec079c4&"
import script from "./UserEditTabTargets.vue?vue&type=script&lang=js&"
export * from "./UserEditTabTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports